import React from 'react';

export const formatNum = <T,>(value: T): T | string =>
  typeof value === 'number'
    ? new Intl.NumberFormat('en-US').format(value).replace(/,/g, ' ')
    : value;

export const trendOf = (percentage: unknown): number | null =>
  typeof percentage === 'number' && Number.isFinite(percentage) && percentage !== 0
    ? percentage
    : null;

export const cardTitle = (text: string) => (
  <span className="text-text_secondary text-sm font-medium">{text}</span>
);

export const cardMetric = (value: React.ReactNode) => (
  <span className="text-[28px] leading-[35px]">{value}</span>
);
